








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Feedback, roleType } from '@/Feedback'
import { TokenUser } from '@/TokenUser'
import { Account } from '@/Account'
import * as utils from '@/utils';
import * as utils_time from '@/utils_time';
import * as utils_topshot from '@/utils_topshot';
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src
import AccountUsernameComponent from '@/components/AccountUsernameComponent.vue';                       // @ is an alias to /src

@Component({
  name: 'FeedbackListComponent',
  components: { ModalWrapperComponent, AccountUsernameComponent }
})
export default class FeedbackListComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public feedback: Feedback

  @Prop({ default: true })
  public showAuthor: boolean

  @Prop({ default: true })
  public showAbout: boolean

  @Prop({ default: 0 })
  public index: number                 // in case it's ever useful for us to know where we are in the main list

  // public reactive member variables available to the html template

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  public get getStarsString(): string { return '★'.repeat(this.feedback.rating) }
  public get getRoleStringForAuthor(): string { return this.feedback.authorRole === roleType.Seller ? 'Seller' : 'Buyer' }
  public get getClassNameForAuthor(): string { return this.feedback.authorRole === roleType.Seller ? 'sellerName' : 'winningName' }
  public get getRoleStringForAbout(): string { return this.feedback.authorRole === roleType.Seller ? 'Buyer' : 'Seller' }
  public get getClassNameForAbout(): string { return this.feedback.authorRole === roleType.Seller ? 'winningName' : 'sellerName' }

  public clickedAuction() {
    const dynamicProps: any = { auctionId: this.feedback.auctionId };
    (this.$refs.AuctionComponent as ModalWrapperComponent).show('Loading auction details...', 'md', dynamicProps);
  }

  public clickedName(flowAddress: string) {
    const url: string = Account.getFeedbackLink(flowAddress)
    if (url) window.open(url, "_blank"); 
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
  }

  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)
  }

}
